<template>
  <div class="newPrize">
    <div class="breadcrumb">
      活动管理 > 奖品管理 >
      <span v-if="edit === false">新增</span>
      <span v-if="edit !== false">编辑</span>
      <span>
        <el-button class="right_f" type="primary" @click="cancel"
          >取消</el-button
        >
        <el-button class="right_f" type="primary" @click="save">保存</el-button>
      </span>
    </div>

    <div class="detail">
      <el-form
        ref="prizeForm"
        :rules="rules"
        :model="prizeForm"
        label-width="160px"
      >
        <el-form-item label="奖品图标：" prop="logoUrl">
          <!-- <el-upload
          :action="actionUrl"
          :with-credentials="true"
          accept="image/*"
          name="uploadFile"
          type="drag"
          :thumbnail-mode="true"
          :on-error="handleError"
          :on-success="handleSuccess" 
         
        >
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload> -->
          <el-upload
            :action="actionUrl"
            :with-credentials="true"
            accept="image/*"
            name="uploadFile"
            type="drag"
            class="upload-demo"
            :thumbnail-mode="true"
            :on-error="handleError"
            :on-success="handleSuccess"
            :show-file-list="false"
          >
            <img
              style="width: 100%; height: 100%"
              v-if="prizeForm.logoUrl"
              :src="prizeForm.logoUrl"
              class="avatar"
            />
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="el-dragger__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="奖品名称：" prop="prizeName">
          <el-input
            v-model="prizeForm.prizeName"
            placeholder="请仔细填写，在APP展示给用户"
            class="prizeTitle"
          ></el-input>
          <span style="color: red">奖品名称建议8个字符</span>
        </el-form-item>
        <el-form-item label="发放时间：" required> 
          <!-- <el-form-item prop="deployStartTime" class="time"> -->
            <el-date-picker
              v-model="prizeForm.deployStartTime"
              format="yyyy/MM/dd HH:mm"
              type="datetime"
              placeholder="yyyy/MM/dd hh:mm"
              class="qizhiDate"
              style="width:200px"
            ></el-date-picker>
          <!-- </el-form-item> -->
           至 
          <!-- <el-form-item prop="deployEndTime" class="time"> -->
            <el-date-picker
              v-model="prizeForm.deployEndTime"
              class="qizhiDate"
              type="datetime"
              format="yyyy/MM/dd HH:mm"
              placeholder="yyyy/MM/dd hh:mm"
              style="width:200px"
            ></el-date-picker>
          <!-- </el-form-item> -->
        </el-form-item>

        <el-form-item label="奖品类型：">
          <el-select v-model="prizeForm.prizeType" style="width: 20%" disabled>
            <el-option label="一级奖励（必中）" value="1"> </el-option>
            <el-option label="一级奖励（限量）" value="3"></el-option>
            <el-option label="二级奖励（随机）" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖励弹窗:" required>
          <el-radio v-model="prizeForm.windowType"  label="0">默认</el-radio>
          <el-radio
            v-model="prizeForm.windowType"
            label="1"
            style="margin-left: 0"
            >自定义</el-radio
          >
          <!-- <el-upload
          v-if="prizeForm.windowType == '1'"
          :action="actionUrl"
          :with-credentials="true"
          accept="image/*"
          name="uploadFile"
          type="drag"
          :thumbnail-mode="true"
          :on-error="handleError"
          :on-success="handleSuccess2" 
          
        >
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload> -->
          <el-upload
            v-if="prizeForm.windowType == 1"
            :action="actionUrl"
            :with-credentials="true"
            accept="image/*"
            name="uploadFile"
            type="drag"
            class="upload-demo"
            :thumbnail-mode="true"
            :on-error="handleError"
            :on-success="handleSuccess2"
            :show-file-list="false"
          >
            <img
              style="width: 100%; height: 100%"
              v-if="prizeForm.windowUrl"
              :src="prizeForm.windowUrl"
              class="avatar"
            />
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="el-dragger__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
            </div>
          </el-upload>
        </el-form-item>

        <!-- ////////////点击事件/////////////// -->
        <el-form-item
          label="点击事件:"
          prop="windowClickType"
          class="click-events"
          required
          v-if="prizeForm.windowType == '1'"
        >
          <el-radio
            v-model="prizeForm.windowClickType"
            label="0"
            style="margin-left: 15px"
            >无跳转</el-radio
          >
          <el-radio v-model="prizeForm.windowClickType" label="1"
            >跳转至URL：</el-radio
          >
          <el-radio v-model="prizeForm.windowClickType" label="2"
            >跳转至已有文章：</el-radio
          >
          <el-radio v-model="prizeForm.windowClickType" label="3"
            >跳转至已有话题：</el-radio
          >
          <el-radio v-model="prizeForm.windowClickType" label="4"
            >跳转至微信小程序：</el-radio
          >
          <el-radio v-model="prizeForm.windowClickType" label="7"
            >跳转至支付宝小程序：</el-radio
          >
          <el-radio v-model="prizeForm.windowClickType" label="5"
            >跳转至音频：</el-radio
          >

          <el-input
            v-model="prizeForm.windowClickUrl"
            class="activityTitle"
            v-if="shieldArray2.indexOf(prizeForm.windowClickType) > -1"
            :placeholder="placeholder"
          ></el-input>
        </el-form-item>
        <!-- 微信小程序 -->
        <div
          v-if="prizeForm.windowType == '1' && prizeForm.windowClickType == '4'"
          class="wx-app"
        >
          <el-form-item
            label="小程序原始Id："
            prop="wxAppId"
            class="wxApp-from"
            required
          >
            <el-input
              v-model="prizeForm.wxAppId"
              placeholder="请填写正确的小程序原始Id"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="路径地址：" prop="wxAppUrl" class="wxApp-from">
            <el-input
              v-model="prizeForm.wxAppUrl"
              placeholder="请填写正确的路径地址"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 支付宝小程序 -->
        <div
          v-if="prizeForm.windowType == '1' && prizeForm.windowClickType == '7'"
          class="wx-app"
        >
          <el-form-item
            label="小程序原始Id："
            prop="aliAppId"
            class="wxApp-from"
            required
          >
            <el-input
              v-model="prizeForm.aliAppId"
              placeholder="请填写正确的小程序原始Id"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="路径地址：" prop="aliAppUrl" class="wxApp-from">
            <el-input
              v-model="prizeForm.aliAppUrl"
              placeholder="请填写正确的路径地址"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 音频 -->
        <div
          v-if="prizeForm.windowType == '1' && prizeForm.windowClickType == '5'"
          class="wx-app"
        >
          <el-form-item
            label="专辑ID："
            prop="albumId"
            class="wxApp-from"
            required
          >
            <el-input
              v-model="prizeForm.albumId"
              placeholder="请填写专辑ID"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="主播名称："
            prop="nickName"
            class="wxApp-from wx-app"
            style="margin-bottom: 22px"
            required
          >
            <el-input
              v-model="prizeForm.nickName"
              placeholder="请填写主播名称"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="单曲数："
            prop="albumCount"
            class="wxApp-from"
            required
          >
            <el-input
              v-model="prizeForm.albumCount"
              placeholder="请填写单曲数"
              type="number"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否付费："
            prop="isPaid"
            class="wxApp-from"
            required
          >
            <el-radio
              v-model="prizeForm.isPaid"
              label="1"
              style="margin-left: 15px"
              >是</el-radio
            >
            <el-radio v-model="prizeForm.isPaid" label="0">否</el-radio>
          </el-form-item>
        </div>
        <!-- ////////////////////////// -->
        <el-form-item label="奖励里程：" prop="prizeDisType">
          <el-radio v-model="prizeForm.prizeDisType" label="1">不奖励</el-radio>
          <el-radio
            v-model="prizeForm.prizeDisType"
            label="2"
            style="margin-left: 0"
            class="inline"
            >双倍</el-radio
          >
          <el-radio v-model="prizeForm.prizeDisType" label="3" class="inline"
            >自定义</el-radio
          >
          <div v-if="prizeForm.prizeDisType == '3'" style="display: flex; flex-direction: column; gap: 10px;">
            <el-input
              v-model="prizeForm.prizeDis"
              type="number"
              min="0"
              placeholder="请输入奖励公里数"
              class="prizekm"
            ></el-input>
            <el-input
              v-model="prizeForm.prizeTimes"
              type="number"
              min="1"
              placeholder="请输入奖励次数"
              class="prizekm"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item label="兑奖URL：" prop="prizeUrl">
          <el-radio v-model="prizeForm.definePrizeUrl" label="false"
            >同活动详情URL（若无活动详情URL则不跳转，请检查确认）</el-radio
          >
          <br />
          <el-radio
            v-model="prizeForm.definePrizeUrl"
            label="true"
            class="inline"
            >自定义URL</el-radio
          >

          <el-input
            v-model="prizeForm.prizeUrl"
            v-if="prizeForm.definePrizeUrl == 'true'"
            class="prizeTitle"
          ></el-input
          ><br />
          <span v-if="prizeForm.definePrizeUrl == 'true'" style="color: #666"
            >配置微信小程序URL示例：zjwh://weChatProgram?id=<span class="red"
              >111111</span
            >
            或者 zjwh://weChatProgram?id=<span class="red">111111</span
            >&path=<span class="red">111111</span></span
          >
        </el-form-item>

        <el-form-item
          label="第三方奖励ID："
          prop="defineText1"
          class="prizeTitle"
        >
          <el-input type="text" placeholder="" v-model="prizeForm.defineText1">
          </el-input>
        </el-form-item>

        <el-form-item
          label="广告曝光代码："
          prop="adExposingCodes"
          class="prizeContent"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 5 }"
            placeholder="在这里粘贴"
            v-model="prizeForm.adExposingCodes"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="文案：" prop="redeem">
          <el-radio
            v-model="prizeForm.redeem"
            label="true"
            :disabled="isDisabled"
            >兑换码类型</el-radio
          >
          <br />
          <el-form-item
            label="文字说明："
            label-width="100px"
            v-if="prizeForm.redeem == 'true'"
            prop="redeemText"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4 }"
              v-model="prizeForm.redeemText"
              class="prizeText"
              style="min-width: 200px; display: inline-block"
            ></el-input>
          </el-form-item>
          <el-radio v-model="prizeForm.redeem" label="false" class="inline"
            >自定义文案</el-radio
          >
          <br />
          <el-form-item
            label="文案内容："
            label-width="100px"
            v-if="prizeForm.redeem == 'false'"
            prop="defineText2"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4 }"
              v-model="prizeForm.defineText2"
              class="prizeText"
              style="min-width: 200px; display: inline-block"
            ></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item label="奖品兑换有效期：" prop="qizhiDate">
          <!-- <el-form-item prop="redeemStartTime" class="time"> -->
            <el-date-picker
              v-model="prizeForm.redeemStartTime"
              format="yyyy/MM/dd"
              placeholder="yyyy/MM/dd"
              class="qizhiDate"
              style="width:200px"
            ></el-date-picker>
          <!-- </el-form-item> -->
          至 
          <!-- <el-form-item prop="redeemEndTime" class="time"> -->
            <el-date-picker
              v-model="prizeForm.redeemEndTime"
              class="qizhiDate"
              format="yyyy/MM/dd"
              placeholder="yyyy/MM/dd"
              style="width:200px"
            ></el-date-picker>
          <!-- </el-form-item> -->
          <el-button @click="clearTime">清空时间</el-button>
        </el-form-item>

        <el-form-item label="奖品详细数据：" prop="uploadFile">
          <div v-if="prizeForm.prizeType != 3">
            <el-upload
              :action="importUrlAction"
              :with-credentials="true"
              style="display: inline-block"
              :on-success="success"
              :on-error="handleError"
              name="uploadFile"
              v-if="isable === true"
            >
              <el-button>选择文件</el-button>
            </el-upload>
            <el-button disabled v-if="isable === false">选择文件</el-button>
            <span v-if="prizeForm.prizeType == '2'"
              >({{ prizeForm.import }})</span
            >
            <span v-if="prizeForm.prizeType == '1'" style="color: red"
              >必中奖品数量不限，无需导入文件</span
            >
          </div>

          <el-row v-if="prizeForm.prizeType == 3">
            <el-col :span="24">
              <el-radio
                v-model="prizeForm.prizeFromType"
                label="1"
                style="display: inline-block"
                >总共</el-radio
              >
              <div
                style="display: inline-block"
                v-if="prizeForm.prizeFromType == '1'"
              >
                <input v-model="prizeForm.prizeNum" style="outline: none" /> 个
                （所有参与学校均可领取）
              </div>
            </el-col>
            <el-col :span="24">
              <el-radio
                v-model="prizeForm.prizeFromType"
                label="2"
                style="display: inline-block"
                >每个学校</el-radio
              >
              <div
                style="display: inline-block"
                v-if="prizeForm.prizeFromType == '2'"
              >
                <input v-model="prizeForm.prizeNum" style="outline: none" /> 个
              </div>
            </el-col>
            <el-upload
              :action="importUrlAction2"
              :with-credentials="true"
              style="display: inline-block"
              :on-success="success"
              :on-error="handleError"
              name="uploadFile"
              v-if="isable === true"
            >
              <el-button>选择文件</el-button>
            </el-upload>
            <el-button disabled v-if="isable === false">选择文件</el-button>
            <span v-if="prizeForm.prizeType == '3'"
              >({{ prizeForm.import }})</span
            >
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  data() {
    let checkUrl = function (rule, value, callback) {
      if (this.prizeForm.definePrizeUrl) {
        return callback({ required: true });
      }
    };
    return {
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=9",
      importUrl: this.$util.domain + "/adminapi/v1/operate/prize/import",
      importUrl2: this.$util.domain + '/adminapi/v2/operate/prize/import',
      edit: false,
      isable: false,
      isDisabled: false,
      prizeId: "",
      startTime: "",
      endTime: "",
      prizeForm: {
        prizeName: "",
        logoUrl: "",
        redeem: "true",
        prizeUrl: "",
        prizeType: "1",
        prizeDisType: "1",
        prizeDis: "",
        prizeTimes: "",
        definePrizeUrl: 'false',
        deployStartTime: "",
        deployEndTime: "",
        redeemStartTime: "",
        redeemEndTime: "",
        uploadFile: "",
        redeemText: "",
        adExposingCodes: "",
        defineText1: "",
        defineText2: "",
        import: "未导入",
        /////////////////////v2新增
        windowType: '0',
        windowUrl: "",
        prizeFromType: '1',
        prizeNum: "",
        windowClickType: "0",
        windowClickUrl: "",
        /* 微信支付宝音频信息 */
        wxAppId: "",
        wxAppUrl: "",
        aliAppId: "",
        aliAppUrl: "",
        albumId: "",
        nickName: "",
        albumCount: "",
        isPaid: "",
      },
      shieldArray2: ['1', '2', '3'], //根据这个数组判断是否 为 微信支付宝音频信息
      rules: {
        logoUrl: [
          { required: true, message: "请导入奖品图标", trigger: "change" },
        ],
        prizeName: [
          {
            required: true,
            min: 1,
            max: 16,
            message: "请填写正确的名称,不超过16个字符",
            trigger: "blur",
          },
        ],
        deployStartTime: [
          {
            type: "date",
            required: true,
            message: "请填写正确的开始日期",
            trigger: "change",
          },
        ],
        deployEndTime: [
          {
            type: "date",
            required: true,
            message: "请填写正确的结束日期,且结束日期不得早于开始日期",
            trigger: "change",
          },
        ],
        prizeUrl: [{ message: "请填写正确的URL", trigger: "change" }],
        uploadFile: [{ message: "请导入奖品详细数据", trigger: "change" }],
        redeem: [{ message: "请填写文案", trigger: "change" }],
        defineText2: [{ message: "请填写文案", trigger: "blur" }],
        redeemText: [
          { require: false, message: "请填写文案", trigger: "blur" },
        ],
      },
    };
  },
  watch:{
   /*  isable:{
      handler(n){
        console.log('isable',n) 
      },
      immediate:true
    } */
  },
  mounted() {
    let url = window.location.href;
    this.getActivityDetail();
    if (url.indexOf("edit") !== -1) {
      this.edit = true;
      this.prizeId = this.$util.getUrlParam("prizeId");
      this.getPrizeDetail(this.prizeId);
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    importUrlAction() {
      return this.importUrl + "?prizeId=" + this.prizeId;
    },
    importUrlAction2() {
      return this.importUrl2 + "?prizeId=" + this.prizeId;
    },
  },
  methods: {
    ...mapActions(["SIGNOUT"]),
    /**
     * 获取活动详情
     * **/
    getActivityDetail() {
      this.activityId = this.$util.getUrlParam("activityId");
      this.$http({
        method: "POST",
        url: `${this.$util.domain}/adminapi/v1/operate/activity/queryByActivityId?activityId=${this.activityId}`,
      }).then((response) => {
        if (response.data.error === 10000) {
          let data = response.data.data;
          this.startTime = new Date(data.startTime + " 00:00").getTime();
          this.endTime = new Date(data.endTime + " 23:59").getTime();
          this.prizeForm.prizeType = data.prizeType + "";  
          if (this.prizeForm.prizeType == "1") {
            this.isDisabled = true;
            this.isable = false; 
            this.prizeForm.redeem = "false";
          }
        }
      });
    },
    clearTime() {
      this.prizeForm.redeemStartTime = "";
      this.prizeForm.redeemEndTime = "";
    },
    /**
     * 比较时间
     * ***/
    compareTime(s, e) {
      return (
        s.getTime() < this.startTime ||
        s.getTime() > this.endTime ||
        e.getTime() < this.startTime ||
        e.getTime() > this.endTime
      );
    },
    /**新增和编辑奖品**/
    add() {
      let deployStartTime = new Date(this.prizeForm.deployStartTime).format(
        "yyyy-MM-dd hh:mm"
      );
      deployStartTime = new Date(deployStartTime);
      let deployEndTime = new Date(this.prizeForm.deployEndTime).format(
        "yyyy-MM-dd hh:mm"
      );
      deployEndTime = new Date(deployEndTime);
      if (deployStartTime.getTime() > deployEndTime.getTime()) {
        this.$util.errorMsg("请选择正确的日期，且结束日期不得早于开始日期");
        return;
      }
      let redeemStartTime, redeemEndTime;
      if (
        (this.prizeForm.redeemStartTime && !this.prizeForm.redeemEndTime) ||
        (!this.prizeForm.redeemStartTime && this.prizeForm.redeemEndTime)
      ) {
        this.$util.errorMsg("请选择兑奖有效期的开始与结束时间");
        return;
      }

      if (this.prizeForm.redeemStartTime && this.prizeForm.redeemEndTime) {
        redeemStartTime = new Date(this.prizeForm.redeemStartTime).format(
          "yyyy-MM-dd 00:00"
        );
        redeemStartTime = new Date(redeemStartTime);
        redeemEndTime = new Date(this.prizeForm.redeemEndTime).format(
          "yyyy-MM-dd 23:59"
        );
        redeemEndTime = new Date(redeemEndTime);
        if (redeemStartTime.getTime() > redeemEndTime.getTime()) {
          this.$util.errorMsg("请选择正确的日期，且结束日期不得早于开始日期");
          return;
        }
        redeemStartTime = redeemStartTime.getTime();
        redeemEndTime = redeemEndTime.getTime();
      } else {
        redeemStartTime = -1;
        redeemEndTime = -1;
      }

      if (this.compareTime(deployStartTime, deployEndTime)) {
        this.$util.errorMsg("请选择正确的时间，发放时间需为活动起止日期的子集");
        return;
      }

      if (this.prizeForm.definePrizeUrl == 'false') {
        this.prizeForm.prizeUrl = "";
      }
      if (
        this.prizeForm.definePrizeUrl == 'true' &&
        this.prizeForm.prizeUrl == ""
      ) {
        this.$util.errorMsg("自定义URL,请填写正确URL");
        return;
      }
      if (this.prizeForm.redeem === "true") {
        this.prizeForm.defineText2 = "";
      } else {
        this.prizeForm.redeemText = "";
      }

      if (this.prizeForm.prizeDisType == "3") {
        let value = this.prizeForm.prizeDis * 1;
        if (!this.isZhengshu(value) || !value) {
          this.$util.errorMsg("请填写正确奖励公里数");
          return;
        }
        if (value > 10) {
          this.$util.errorMsg("自定义奖励里程上限为10公里");
          return;
        }
        // 验证奖励次数
        let timesValue = parseInt(this.prizeForm.prizeTimes);
        if (!this.prizeForm.prizeTimes || isNaN(timesValue) || timesValue <= 0 || timesValue != this.prizeForm.prizeTimes) {
          this.$util.errorMsg("请填写正确的奖励次数");
          return;
        }
      } else {
        this.prizeForm.prizeDis = "";
        this.prizeForm.prizeTimes = "";
      }

      if (this.prizeForm.redeem === "false") {
        if (this.prizeForm.defineText2 == "") {
          this.$util.errorMsg("自定义文案,文案内容是必填项");
          return;
        }
        if (this.prizeForm.defineText2.length > 80) {
          this.$util.errorMsg("文案内容不得超过80个字符");
          return;
        }
      }

      if (
        this.prizeForm.redeem === "true" &&
        this.prizeForm.redeemText.length > 80
      ) {
        this.$util.errorMsg("文案内容不得超过80个字符");
        return;
      }
      /* hhhhhhhhhhhhhhh */
      // 验证url地址2
      if (
        this.shieldArray2.indexOf(this.prizeForm.windowClickType) > -1 &&
        !this.prizeForm.windowClickUrl.trim()
      ) {
        this.$util.errorMsg("点击事件的id或者url不能为空！");
        return;
      }

      if (this.prizeForm.windowClickType == 4) {
        if (!this.prizeForm.wxAppId.trim()) {
          this.$util.errorMsg("微信小程序的原始id不能为空！");
          return;
        }
        if (this.prizeForm.wxAppId.indexOf("id=") > -1) {
          this.$util.errorMsg("微信小程序的原始id输入格式错误！");
          return;
        }
      }

      if (this.prizeForm.windowClickType == 7) {
        if (!this.prizeForm.aliAppId.trim()) {
          this.$util.errorMsg("支付宝小程序的原始id不能为空！");
          return;
        }
        if (this.prizeForm.aliAppId.indexOf("appId=") > -1) {
          this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
          return;
        }
      }

      if (this.prizeForm.windowClickType == 5) {
        if (!this.prizeForm.albumId.trim()) {
          this.$util.errorMsg("专辑ID不能为空！");
          return;
        }
        if (!this.prizeForm.nickName.trim()) {
          this.$util.errorMsg("主播名称不能为空！");
          return;
        }
        var re = /^[0-9]+$/;
        if (!this.prizeForm.albumCount || !re.test(this.prizeForm.albumCount)) {
          this.$util.errorMsg("单曲数输入有误！");
          return;
        }
      }
      // 整理url入参格式222222
      if (this.prizeForm.windowClickType == 0) {
        this.prizeForm.windowClickUrl = "";
      } else if (this.prizeForm.windowClickType == 4) {
        // 小程序的id和url作为两个参数拼成字符串传给后台
        if (this.prizeForm.wxAppUrl && this.prizeForm.wxAppUrl.trim()) {
          this.prizeForm.windowClickUrl =
            "id=" +
            this.prizeForm.wxAppId.trim() +
            "&path=" +
            this.prizeForm.wxAppUrl.trim();
        } else {
          this.prizeForm.windowClickUrl = "id=" + this.prizeForm.wxAppId.trim();
        }
      } else if (this.prizeForm.windowClickType == 5) {
        // 音频参数
        this.prizeForm.windowClickUrl =
          "id=" +
          this.prizeForm.albumId +
          "&nickName=" +
          this.prizeForm.nickName +
          "&count=" +
          this.prizeForm.albumCount +
          "&isPaid=" +
          this.prizeForm.isPaid;
      } else if (this.prizeForm.windowClickType == 7) {
        // 小程序的id和url作为两个参数拼成字符串传给后台
        if (this.prizeForm.aliAppId && this.prizeForm.aliAppUrl.trim()) {
          this.prizeForm.windowClickUrl =
            "appId=" +
            this.prizeForm.aliAppId.trim() +
            "&page=" +
            this.prizeForm.aliAppUrl.trim();
        } else {
          this.prizeForm.windowClickUrl =
            "appId=" + this.prizeForm.aliAppId.trim();
        }
      }

      let url = this.$util.domain + "/adminapi/v2/operate/prize/insert";
      let requestBody = {
        activityId: this.activityId * 1,
        logoUrl: this.prizeForm.logoUrl,
        prizeName: this.prizeForm.prizeName,
        deployStartTime: deployStartTime,
        deployEndTime: deployEndTime,
        redeemStartTime: redeemStartTime,
        redeemEndTime: redeemEndTime,
        prizeType: this.prizeForm.prizeType * 1,
        prizeDisType: this.prizeForm.prizeDisType * 1,
        prizeDis: this.prizeForm.prizeDis,
        prizeTimes: this.prizeForm.prizeTimes,
        defineText1: this.prizeForm.defineText1,
        defineText2: this.prizeForm.defineText2,
        definePrizeUrl: this.prizeForm.definePrizeUrl==='true'?true:false,
        prizeUrl: this.prizeForm.prizeUrl,
        adExposingCodes: this.prizeForm.adExposingCodes,
        redeemText: this.prizeForm.redeemText,
        redeem: this.prizeForm.redeem,
        windowType: this.prizeForm.windowType*1,
        windowUrl:
          this.prizeForm.windowType == 0 ? "" : this.prizeForm.windowUrl,
        windowClickType: this.prizeForm.windowClickType*1,
        windowClickUrl: this.prizeForm.windowClickUrl, //各种url转化
        prizeFromType: this.prizeForm.prizeFromType*1,
        prizeNum: this.prizeForm.prizeNum * 1,
      };

      if (this.edit) {
        url = this.$util.domain + "/adminapi/v2/operate/prize/update";
        requestBody.prizeId = this.$util.getUrlParam("prizeId") * 1;
      }
      this.$http({
        url,
        method: "POST",
        body: JSON.stringify(requestBody),
      })
        .then((response) => {
          if (response.data.error === 10000) {
            if (this.prizeForm.prizeType == "1") {
              this.isable = false; 
            } else { 
              this.isable = true;
            }
            this.$util.successMsg("操作成功");
            window.history.go(-1);
          } else {
            this.$util.errorMsg(response.data.message);
          }
        })
        .catch((response) => {
          this.$util.successMsg("操作失败");
        });
    },

    //****验证自定义奖励里程是否为正数 */
    isZhengshu(value) {
      let reg = /^\d+(?=\.{0,1}\d+$|$)/;
      if (reg.test(value)) return true;
      return false;
    },

    //***获取奖品详情，用于在编辑页面中展示**//
    getPrizeDetail(id) {
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/v2/operate/prize/queryByPrizeId?prizeId=" +
          id,
      }).then((response) => {
        if (response.data.error === 10000) {
          console.log("修改详情", response.data);
          let data = response.data.data;
          if (data.definePrizeUrl==false) {
            data.prizeUrl = "";
          }

          // 点击事件的ID或URL的整理2222
          let windowClickUrl = "",
            wxAppId2 = "",
            wxAppUrl2 = "",
            aliAppId2 = "",
            aliAppUrl2 = "",
            albumId2,
            nickName2,
            albumCount2,
            isPaid2 = '0';
          if (data.windowClickType == 4) {
            // 微信小程序地址拆分
            wxAppId2 = this.$util.getUrlParam("id", data.windowClickUrl);
            wxAppUrl2 = this.$util.getUrlParam("path", data.windowClickUrl);
          } else if (data.windowClickType == 7) {
            // 支付宝小程序地址拆分
            aliAppId2 = this.$util.getUrlParam("appId", data.windowClickUrl);
            aliAppUrl2 = this.$util.getUrlParam("page", data.windowClickUrl);
            let query = this.$util.getUrlParam("query", data.targetUrl);
            if (query) {
              aliAppUrl2 = aliAppUrl2 + "&query=" + query;
            }
          } else if (data.windowClickType == 0) {
            windowClickUrl = "";
          } else if (data.windowClickType == 5) {
            // 音频
            albumId2 = this.$util.getUrlParam("id", data.windowClickUrl);
            nickName2 = this.$util.getUrlParam("nickName", data.windowClickUrl);
            albumCount2 = this.$util.getUrlParam("count", data.windowClickUrl);
            isPaid2 = this.$util.getUrlParam("isPaid", data.windowClickUrl);
          } else {
            windowClickUrl = data.windowClickUrl;
          }

          this.prizeForm = {
            logoUrl: data.logoUrl,
            prizeName: data.prizeName,
            prizeUrl: data.prizeUrl,
            deployStartTime: new Date(data.deployStartTime),
            deployEndTime: new Date(data.deployEndTime),
            redeemStartTime:
              data.redeemStartTime != -1 ? new Date(data.redeemStartTime) : "",
            redeemEndTime:
              data.redeemEndTime != -1 ? new Date(data.redeemEndTime) : "",
            prizeType: data.prizeType.toString(),
            prizeDisType: data.prizeDisType.toString(),
            prizeDis: data.prizeDis ? data.prizeDis.toString() : "",
            prizeTimes: data.prizeTimes ? data.prizeTimes.toString() : "",
            redeemText: data.redeemText || "",
            defineText1: data.defineText1,
            defineText2: data.defineText2,
            definePrizeUrl: data.definePrizeUrl?'true':'false',
            adExposingCodes: data.adExposingCodes,
            import: data.import ? "已导入" : "未导入",
            redeem: data.redeem.toString(),
            /* v2新增参数 */
            windowType: data.windowType+"",
            windowUrl: data.windowUrl,
            windowClickType: data.windowClickType+"",
            windowClickUrl: windowClickUrl ? windowClickUrl + "" : "",
            prizeFromType: data.prizeFromType+"",
            prizeNum: data.prizeNum,
            /* 拼接数据url */
            wxAppId: wxAppId2,
            wxAppUrl: wxAppUrl2,
            aliAppId: aliAppId2,
            aliAppUrl: aliAppUrl2,
            albumId: albumId2,
            nickName: nickName2,
            albumCount: albumCount2,
            isPaid:  isPaid2+"",
          };

          if (this.prizeForm.prizeType == "2"||this.prizeForm.prizeType == "3") {
            this.isable = true;  
          }
        }
      });
    },
    //**保存**//
    save() {
      this.$refs.prizeForm.validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("error submit");
        }
      });
    },
    /**
     * 取消
     **/
    cancel() {
      window.history.go(-1);
    },
    /**
     *上传文件成功钩子
     **/
    handleSuccess(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.prizeForm.logoUrl = response.data;
      }
    },
    handleSuccess2(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.prizeForm.windowUrl = response.data;
      }
    },
    success(response) {
      console.log(response)
      if (response.error !== 10000) {
        this.$util.errorMsg(response.message);
      } else {
        this.$util.successMsg("上传成功");
        this.prizeForm.uploadFile = response.data;
        this.prizeForm.import = "已导入";
      }
    },
    /**上传文件失败钩子**/
    handleError(response) {
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }

      this.$util.errorMsg("上传失败");
    },
  },
};
</script>
<style   >
.el-radio {
  display: block;
}
.btn_prize {
  float: right;
  margin-right: 10px;
}

.red {
  color: red;
}
.newPrize {
  overflow: hidden;
}

.inline {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 15px;
}

.btn_prize + .btn_prize {
  margin-left: 0;
}

.prizeTitle {
  width: 45%;
  display: inline-block;
  margin-right: 10px;
}

.newPrize .prizeText {
  width: 40%;
}

.prizelimitCount {
  width: 15%;
  display: inline-block;
}

.prizeType {
  width: 20%;
}

.qizhiDate {
  /* display: inline-block;
  width: 100%; */
}

.prizeContent {
  width: 98%;
}

.newPrize .campContain {
  margin-left: 260px;
  width: 700px;
  height: 135px;
  border: solid 1px gray;
  box-sizing: border-box;
}

.newPrize .campSpan {
  display: block;
  text-align: center;
  float: left;
  height: 30px;
  padding: 5px 30px 5px 15px;
  border: solid 1px #999;
  border-radius: 5px;
  margin: 10px;
  box-sizing: border-box;
  font-size: 12px;
  position: relative;
}

.campSpan i {
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #999;
  position: absolute;
  right: 5px;
  top: 5px;
}

.newPrize .time {
  /* display: inline-block;
  width: 15%; */
}

.newPrize .right {
  position: relative;
  left: 60px;
  top: -20px;
}

.el-picker-panel__footer a {
  display: inline-block;
  width: 54px;
  color: rgb(71, 86, 105);
}

.el-picker-panel__footer a:link {
  display: inline-block;
  width: 54px;
  color: rgb(71, 86, 105);
}

.prizekm {
  display: inline-block;
  width: 15%;
}

.prizeContent {
  min-width: 700px;
  width: 70%;
}

.newPrize .el-upload {
 
  padding: 5px;
  /* width: 90px; */
}
</style>


// WEBPACK FOOTER //
// newPrize.vue?81af1702